import { services } from "@services";

export const languageServiceMap: { [key: string]: string } = {
  embedded_development_services: "rozwoj_systemow_wbudowanych",
  embedded_software_outsourcing: "rozwoj_systemow_wbudowanych",
  mvp_development: "mvp_development_pl",
  rtos_development: "rtos_development_pl",
  ux_ui_design_services: "ux_ui_design_uslugi",
  rozwoj_systemow_wbudowanych: "embedded_development_services",
  rozwoj_oprogramowania_embedded: "embedded_development_services",
  mvp_development_pl: "mvp_development",
  rtos_development_pl: "rtos_development",
  ux_ui_design_uslugi: "ux_ui_design_services",
};

export const getServiceLanguage = (slug: string): string => {
  if (Object.keys(services.en).includes(slug)) {
    return "en";
  }

  if (Object.keys(services.pl).includes(slug)) {
    return "pl";
  }

  return "en";
};
